export default __webpack_public_path__ + "static/illustration-action.url-a89177a73ce9e470fa4706444db50928.svg";